// Team-related filters

import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

export const teamFilters: FilterRegistry = {
	teamKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search by team name...',
			objectTable: 'team',
			listKeys: ['team'],
			fulltextFields: ['team_name'],
		}),
		queryParamName: 'teamKeywords',
	},
};
